type Props = {
  label?: string;
};

/** Inline loader for inbox / thread panels (not full viewport). */
export function MessageHubLoading({ label = 'Message Hub' }: Props) {
  return (
    <div
      className="mh-inline-loading"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={`Loading ${label}`}
    >
      <div className="mh-inline-loading__spinner" aria-hidden />
      <p className="mh-inline-loading__label">Loading {label}....</p>
    </div>
  );
}
